import { render, staticRenderFns } from "./ToolsActions.vue?vue&type=template&id=2dc96fa5&"
import script from "./ToolsActions.vue?vue&type=script&lang=js&"
export * from "./ToolsActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports